class ProductCard extends HTMLElement {
    connectedCallback() {
        
        this.handle = this.dataset.productHandle;
        if (!this.handle) {
            console.warn('ProductCard: відсутній атрибут data-product-handle');
            return;
        }

        
        this.variantButtons = Array.from(this.querySelectorAll(".card-variant-btn"));
        this.addButtons = Array.from(this.querySelectorAll("[data-add-to-cart]"));
        this.notifyButtons = Array.from(this.querySelectorAll("[data-notify-btn]"));

        
        const activeBtn = this.querySelector(".card-variant-btn.active");
        this.currentVariantId = activeBtn 
            ? activeBtn.dataset.variantId 
            : (this.dataset.firstVariantId || null);

        this.initEvents();
    }

    initEvents() {
        
        this.variantButtons.forEach((btn) => {
            btn.addEventListener("click", (e) => this.handleVariantChange(e, btn));
        });

        
        this.addButtons.forEach((btn) => {
            btn.addEventListener("click", (e) => this.addToCart(e, btn));
        });

        

        this.notifyButtons.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                document.dispatchEvent(new CustomEvent('popup:notify:open', { 
                    detail: { 
                        handle: this.handle,
                        variantId: this.currentVariantId
                    } 
                }));
            });
        });
    }

    /**
     * Обробляє зміну варіації товару
     * @param {Event} e 
     * @param {HTMLElement} btn 
     */
    handleVariantChange(e, btn) {
        e.preventDefault();

        
        this.variantButtons.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        
        
        this.currentVariantId = btn.dataset.variantId;

        
        const isAvailable = btn.dataset.available === "true";
        this.toggleActionButtons(isAvailable);
    }

    /**
     * Показує/Ховає кнопки залежно від наявності товару
     * @param {boolean} isAvailable 
     */
    toggleActionButtons(isAvailable) {
        this.addButtons.forEach(btn => {
            btn.classList.toggle('hidden', !isAvailable);
            btn.classList.toggle('hidden!', !isAvailable);
        });

        this.notifyButtons.forEach(btn => {
            btn.classList.toggle('hidden', isAvailable);
            btn.classList.toggle('hidden!', isAvailable);
        });
    }

    /**
     * Додає поточну варіацію в кошик через Shopify AJAX API
     * @param {Event} e 
     * @param {HTMLElement} button 
     */
    async addToCart(e, button) {
        e.preventDefault();

        if (!this.currentVariantId) {
            console.error("ProductCard: відсутній ID варіації.");
            return;
        }

        
        button.classList.add("loading");
        this.addButtons.forEach(btn => btn.setAttribute("disabled", "true"));

        try {
            const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items: [{ id: this.currentVariantId, quantity: 1 }] })
            });

            const data = await response.json();

            
            if (!response.ok) {
                throw new Error(data.description || "Помилка додавання до кошика");
            }

            
            document.dispatchEvent(
                new CustomEvent("cart:item-added", {
                    detail: {
                        handle: this.handle,
                        addedVariantId: this.currentVariantId
                    }
                })
            );
            document.dispatchEvent(new CustomEvent("cart:updated"));
        } catch (error) {
            console.error("Помилка додавання в кошик:", error);
            
            alert(error.message); 
        } finally {
            
            button.classList.remove("loading");
            this.addButtons.forEach(btn => btn.removeAttribute("disabled"));
        }
    }
}


if (!customElements.get("product-card")) {
    customElements.define("product-card", ProductCard);
}